import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';
import { SHIPPING_MODE } from '../../../../filters/constants';

export const ShippingMode = {
  id: SHIPPING_MODE,
  displayName: <FormattedMessage {...messages.shippingMode} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'FulfillmentType',
  shouldHideActionButtons: true,
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,

  render: (criteriaInformations, existingFilterHelpers) => {
    if (!existingFilterHelpers) {
      return null;
    }
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFilterHelpers);
  },

  // Reverse-maps a saved collection filter back to UI checklist state.
  // Parcel is stored as { values: ['FreightLtl'], isIn: false }; when isIn is false
  // the value 'FreightLtl' must be restored as the synthetic 'Parcel' checklist item.
  mapV2SavedFilterToV3Applied: (value, _column, isIn) => {
    if (value === 'FreightLtl' && isIn === false) {
      return { criterionArgumentValue: 'Parcel', criterionOperatorValue: 'equals' };
    }
    return {};
  },
};
